/**
 A really simple event bus, used to send events to
 catch Tray.io status
 */

import Vue from 'vue';

export default new Vue();
